module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/102/assets/images/8e8f7a7a3df5cc27c9f1bbfdc49b931d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_question.svg
// module id = i+Fm
// module chunks = 0